(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ledlenser-download-library"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-download-search]')) return;
    const query = event.target.value.trim().toLocaleLowerCase();
    let count = 0;
    document.querySelectorAll('[data-download-library]').forEach((library) => {
      let libraryCount = 0;
      const items = [...library.querySelectorAll('.download-library-items > .text-block')];
      let heading;
      let groupHasMatch = false;
      items.forEach((item) => {
        if (item.querySelector('h4')) {
          if (heading) heading.hidden = Boolean(query) && !groupHasMatch;
          heading = item;
          groupHasMatch = false;
          return;
        }
        const matches = item.textContent.toLocaleLowerCase().includes(query);
        item.hidden = !matches;
        if (matches) { count++; libraryCount++; groupHasMatch = true; }
      });
      if (heading) heading.hidden = Boolean(query) && !groupHasMatch;
      library.closest('.section-wrapper').hidden = Boolean(query) && libraryCount === 0 && !library.querySelector('[data-download-search]');
    });
    document.querySelector('[data-download-status]').hidden = count > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
